import { gql } from "@apollo/client";

export const SiteGeoLocationQuery = gql`
query($siteId: String!){
  getSiteGeoLocation(siteId: $siteId) {
    message
    response
  }
}
`;